import axios from 'axios';

import { BASE_URL } from '../store/constants/base.constant';
import { IHttpResponse } from '../shared/interface/http.interface';

export const getAllCategories = async () => {
  const { data } = await axios.get<IHttpResponse<any>>(`${BASE_URL}/categories/dashboard-subcategory-list`);
  return data;
};
